{
  "LOGIN": {
    "TITLE": "Přihlásit se do kontaktního centra",
    "EMAIL": {
      "LABEL": "E-mailová adresa",
      "PLACEHOLDER": "jan{'@'}companyname.com",
      "ERROR": "Zadejte prosím platnou e-mailovou adresu"
    },
    "PASSWORD": {
      "LABEL": "Heslo",
      "PLACEHOLDER": "Heslo"
    },
    "API": {
      "SUCCESS_MESSAGE": "Přihlášení úspěšné",
      "ERROR_MESSAGE": "Nelze se připojit k chat serveru, opakujte akci později",
      "UNAUTH": "Nesprávné uživatelské jméno / heslo. Zkuste to prosím znovu",
      "ACCOUNT_DEACTIVATED": "Váš účet byl deaktivován. Kontaktujte prosím svého správce.",
      "PASSWORD_LOGIN_DISABLED": "Přihlášení heslem je pro váš účet zakázáno. Přihlaste se prosím přes OAuth (např. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Přihlásit se přes Google",
      "BUSINESS_ACCOUNTS_ONLY": "Použijte prosím firemní e-mailovou adresu pro přihlášení",
      "NO_ACCOUNT_FOUND": "Nemohli jsme najít účet pro vaši e-mailovou adresu."
    },
    "FORGOT_PASSWORD": "Zapomněli jste heslo?",
    "CREATE_NEW_ACCOUNT": "Vytvořit nový účet",
    "SUBMIT": "Přihlásit se"
  }
}
